<template>
  <div class="vcomments__item">
    <div class="vcomments__info">
      <v-avatar color="red" size="30" class="mr-3">
        <span class="white--text">
          {{ comment.first_name ? comment.first_name[0] : "-" }}
          {{ comment.last_name ? comment.last_name[0] : "-" }}
        </span>
      </v-avatar>
      <!-- <span class="vcomments__author yellow">{{ comment?.user_id }}</span>
      <span class="vcomments__author red">{{ comment?.comment_id }}</span> -->
      <span class="vcomments__author">
        {{ comment?.first_name || "-" }} {{ comment?.last_name || "-" }}
      </span>
      <!-- <span class="vcomments__time ml-3">3 min ago</span> -->
    </div>
    <blockquote class="vcomments__quote" v-text="comment?.message"></blockquote>

    <!-- NOTE Control BUTTON  -->
    <div class="vcomments__btns">
      <div class="vcomments__bleft">
        <!-- <v-btn
          color="primary"
          fab
          v-if="this.storeGetUserInfo.user_id == comment?.user_id"
          icon
          @click="clickDelete"
        >
          <v-icon class="blue--text" small>mdi-delete</v-icon>
        </v-btn>
        <v-btn v-else icon @click="clickDelete" disabled>
          <v-icon class="blue--text" small>mdi-delete</v-icon>
        </v-btn> -->

        <!-- <span class="vcomments__btn vcomments__btn--edit">edit</span> -->
        <!-- Reply -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <div v-on="on" class="d-inline-block">
              <v-btn icon fab x-small dark @click="clickReply()">
                <v-icon class="green--text" small>mdi-reply</v-icon>
              </v-btn>
            </div>
          </template>
          <span>ตอบกลับ</span>
        </v-tooltip>
        <v-tooltip
          bottom
          v-if="this.storeGetUserInfo.user_id == comment?.user_id"
        >
          <template v-slot:activator="{ on }">
            <div v-on="on" class="d-inline-block">
              <v-btn icon fab x-small dark @click="clickDelete">
                <v-icon class="error--text" small>mdi-delete</v-icon>
              </v-btn>
            </div>
          </template>
          <span>ลบ</span>
        </v-tooltip>
      </div>
      <!-- toggle -->
      <div class="vcomments__bright">
        <!-- <span
          class="vcomments__btn vcomments__btn--toggle"
          v-show="comment?.comments?.length | 0"
          @click="toggleGroup()"
        >
          <v-icon v-if="this.isGroupRolledUp" class="blue--text" small
            >mdi-eye</v-icon
          >
          <v-icon v-else class="blue--text" small>mdi-eye-off</v-icon>
          {{ toggleText }}
        </span> -->
        <span
          class="vcomments__btn vcomments__btn--toggle"
          v-show="comment?.comments?.length | 0"
          @click="toggleGroup()"
        >
          <v-tooltip bottom v-if="this.isGroupRolledUp">
            <template v-slot:activator="{ on }">
              <div v-on="on" class="d-inline-block">
                <v-btn  x-small fab icon>
                  <v-icon class="primary--text" small>mdi-eye</v-icon>
                </v-btn>
              </div>
            </template>
            <span>เปิด</span>
          </v-tooltip>
          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on }">
              <div v-on="on" class="d-inline-block">
                <v-btn x-small fab icon>
                  <v-icon class="primary--text" small>mdi-eye-off</v-icon>
                </v-btn>
              </div>
            </template>
            <span>ปิด</span>
          </v-tooltip>
        </span>
      </div>
    </div>
    <div class="vcomments__add-block" v-show="isReplying">
      <input
        class="vcomments__add-input"
        placeholder="เขียนความเห็น..."
        @input="text"
        ref="input"
        v-model="commentText"
        @keyup.enter="addComment"
      />
      <!-- <div class="vcomments__add-button" @click="addComment">Add</div> -->
      <v-btn icon class="vcomments__add-button" @click="addComment">
        <v-icon class="blue--text">mdi-send</v-icon>
      </v-btn>
    </div>
    <!-- TODO เป็นส่วนสำหรับทำ Recuresive Component สำหรับ Comment ลูก-->
    <v-row
      class="pa-0 ma-0"
      v-if="comment.comments.length > 0 && !isGroupRolledUp"
    >
      <v-col
        cols="12"
        v-for="(i, idx) in comment.comments"
        :key="`${uuid}-${idx}`"
        class="pa-0 ma-0 pb-1"
      >
        <!-- {{ comment?.comments[idx] }} -->
        <Comment :item.sync="comment.comments[idx]" @update="onUpdate">
        </Comment>
      </v-col>
    </v-row>
    <!-- <add-comment ref="form" v-show="isReplying" v-bind:comment="comment" v-on:text="changeText" v-on:addComment="addComment"></add-comment> -->
  </div>
</template>

<script>
// import vComment from '@/components/Comment.vue'
import { uuid } from 'vue-uuid'
import { mapGetters } from 'vuex'
export default {
  name: 'Comment',
  // components: {
  //   vComment
  // },
  // constants: {
  //   vComment
  // },
  props: {
    // comment: {},
    hospital_id: {
      type: String
      // default: 'Untitled'
    },
    job_id: {
      type: String
    },
    value: {
      type: Object,
      default: () => {}
    },
    item: {
      // NOTE สำหรับรับก้อน Comment เพียงก้อนเดียว จาก Parent Element
      type: Object,
      default: () => {}
    }
  },
  // created () {
  //   console.log(this.storeGetUserInfo.user_id)
  // },
  // props: ['comment'],
  data () {
    return {
      isGroupRolledUp: true,
      isReplying: false,
      uuid: uuid.v4(),
      //   commentText: '',
      //   add
      commentText: '',
      StateToggle: ''
      // currentUser เพื่อcheck ว่าตรง UserID กับ commentID ตรงกันไหม่ เพื่อเช็คว่า กดdelet ได้ไห
      // currentUser: ''
    }
  },
  mounted () {},

  methods: {
    // onDelete (val) {
    //   this.$emit('delete', val)
    // },
    onUpdate (val) {
      this.$emit('update', val)
    },
    clickDelete () {
      this.$EventBus.$emit('delete', this.comment.comment_id)
      // console.log(this.comment.comment_id)
    },
    toggleGroup: function () {
      this.isGroupRolledUp = !this.isGroupRolledUp
    },
    clickReply: function () {
      this.isReplying = !this.isReplying
      // if (this.isReplying) {
      //   var self = this

      //   setTimeout(function () {
      //     self.$refs.form.$refs.input.focus()
      //   }, 0)
      // }
    },

    changeText: function (data) {
      this.commentText = data
    },
    // emit: function (data) {
    //   this.$emit('event_child', data)
    // },
    addComment: function () {
      this.isReplying = false
      this.isGroupRolledUp = false
      this.$EventBus.$emit('event_child', {
        parent_id: this.comment.comment_id,
        message: this.commentText
      })
      this.commentText = ''
    },
    // addComment: function () {
    //   this.isReplying = false
    //   this.isGroupRolledUp = false
    //   this.$emit('event_child', {
    //     parent_id: this.ItemsComment.comment_id,
    //     message: this.commentText
    //   })
    // },
    text: function () {
      this.$emit('text', this.commentText.trim())
    }
  },

  computed: {
    ...mapGetters(['storeGetUserInfo']),
    comment: {
      // NOTE ใช้สำหรับแปลงค่า Props ให้เป็น 2way เพื่อส่งข้อมูลออกไปยัง Parent
      get () {
        // NOTE สำหรับดึงค่าจาก Props มาใช้งานหาถูกเรียก
        return this.item
      },
      set (val) {
        // NOTE ใช้สำหรับ Set ค่าและส่งค่าออกไปยัง Parene Element
        this.$emit('update:item', val)
        return val
      }
    },

    replyText: function () {
      if (this.isReplying) {
        return 'Cancel'
      } else {
        return 'Reply'
      }
    },
    toggleText () {
      if (this.isGroupRolledUp) {
        return 'expand'
      } else {
        return 'collapse'
      }
    }
    // replies: function () {
    //   return this.comments2.filter(
    //     (item) => item.parent_id === this.comment.id
    //   )
    // }
  }
}
</script>

<style lang="css" scoped>
/* body {
  padding: 15px;
} */

.vcomments__item {
  padding: 15px;
  /* border: 1px solid #eee;
  border-radius: 6px; */
  margin-top: 15px;
  /* box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.2), 0px 4px 6px rgba(0, 0, 0, 0.1) ,0px 1px 6px rgba(0, 0, 0, 0.2);
  border-radius: 32px 32px 32px 32px; */
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
}
.vcomments__item:first-child {
  margin-top: 10px;
}
.vcomments__author {
  font-weight: bold;
}
.vcomments__time {
  color: #999;
  font-size: 14px;
  margin-left: 4px;
  font-style: italic;
}
.vcomments__quote {
  margin: 8px 0;
  padding: 0;
  border: none;
}
.vcomments__btns {
  /* background: red; */
  border-radius: 4px;
  user-select: none;
  /* &:before,
    &:after {
      content: "";
      display: block;
      clear: both;
    } */
}
.vcomments__btns::before {
  content: "";
  display: block;
  clear: both;
}
.vcomments__btns::after {
  content: "";
  display: block;
  clear: both;
}
.vcomments__btn {
  font-size: 14px;
  cursor: pointer;
  position: relative;
  /* padding: 2px 0; */
}
.vcomments__bleft {
  float: left;
}
.vcomments__bright {
  float: right;
}
.vcomments__btn--toggle {
  color: blue;
}
.vcomments__btn--reply {
  color: green;
}
.vcomments__add-block {
  margin-top: 15px;
  position: relative;
}
.vcomments__add-button {
  position: absolute;
  right: 0;
  top: 5px;
  bottom: 0;
  /* // background: #eee;
    // transition: all 0.2s ease-out;
    cursor: pointer;
    // user-select: none;
    // padding: 11px 20px;
    // border-radius: 40px;
    // &:hover {
    //   background: #8d39ce !important;
    //   color: white;
    // } */
}
.vcomments__add-input {
  box-sizing: border-box;
  width: 100%;
  outline: none;
  border: 1px solid #eee;
  padding: 10px 75px 10px 15px;
  border-radius: 40px;
  transition: all 0.2s ease-out;
  /* // &:focus {
    //   border-color: #df98fd;
    //   & + #{$this} {
    //     &__add-button {
    //       background: #df98fd;
    //       color: white;
    //       transition: all 0.2 ease-in;
    //     }
    //   }
    // } */
}
</style>
